<script setup>
defineProps({
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div :class="`info_section__item info_section__item--${theme}`">
    <p
      v-if="title"
      :class="[
        'info_section__item-title m-0 h4',
        theme === 'black' ? 'white' : '',
      ]"
      v-html="title"
    ></p>
    <NuxtImg
      v-if="image?.src"
      class="info_section__item-image"
      :src="image?.src"
      :alt="image?.alt"
      :height="image?.height"
      :width="image?.width"
      loading="lazy"
    />
    <div
      v-if="description"
      :class="[
        'info_section__item-description body-1-regular',
        theme === 'black' ? 'white' : '',
      ]"
      v-html="description"
    ></div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.info_section__item {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  grid-template-areas: 'title' 'image' 'description';
  @include media-breakpoint-up(sm) {
    gap: 56px;
    grid-template-columns: 5.2fr 6.8fr;
    grid-template-areas: 'title .' 'image description';
  }
  @include media-breakpoint-up(md) {
    gap: 72px;
    grid-template-columns: 3.8fr 4.4fr 3.8fr;
    grid-template-areas: 'title image description';
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 72);
  }
  &-title {
    grid-area: title;
  }
  &-image {
    grid-area: image;
    border-radius: 8px;
    max-width: 100%;
    height: auto;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 8);
    }
  }
  &-description {
    grid-area: description;
    &:deep(p:last-child) {
      margin: 0;
    }
  }
}
</style>
